/**
 * Directive to display Email or Emails (plural) based on count
 *
 * Usage: use 'count' parameter to set the number of emails
 * <mss-delivery-format count='number'/>
 */
angular.module('qkr').directive('mssDeliveryFormat', () => ({
        restrict: 'E',
        template: '{{display}}',
        scope: {
            count: '='
        },
        link(scope, elem, attrs) {
            if (scope.count == 1) {
                scope.display = scope.count + ' Email';
            } else {
                scope.display = scope.count + ' Emails';
            }

            return;
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/report/deliveryEmailsFormat.js